import { takeLatest } from 'redux-saga/effects';
import {
  getCountryListSuccess, getCountryListFail,
  getEmployeeListSuccess, getEmployeeListFail,
} from './optionlistState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/console/options');

function* getCountryList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('country-list',data.payload), 
		getCountryListSuccess, 
		getCountryListFail);
}

function* getEmployeeList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('employee-list',data.payload), 
		getEmployeeListSuccess, 
		getEmployeeListFail);
}

function* optionlistSaga() {
  yield takeLatest('optionlist/getCountryList', getCountryList);
  yield takeLatest('optionlist/getEmployeeList', getEmployeeList);
}


export default optionlistSaga;
